import { render, staticRenderFns } from "./Pgy.vue?vue&type=template&id=70a2f8a6&scoped=true&"
import script from "./Pgy.vue?vue&type=script&lang=js&"
export * from "./Pgy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2f8a6",
  null
  
)

export default component.exports